const FilterGroupSkeleton = () => (
  <div className="bg-[#F2F9FA] flex flex-col gap-2 rounded-xl p-4 animate-pulse">
    <div className="flex justify-between mb-1">
      <div className="h-4 bg-gray-300 rounded w-20"></div>
      <div className="w-4 h-4 bg-gray-300 rounded"></div>
    </div>
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <div className="h-3 bg-gray-300 rounded w-24"></div>
        <div className="w-4 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="flex justify-between">
        <div className="h-3 bg-gray-300 rounded w-28"></div>
        <div className="w-4 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="flex justify-between">
        <div className="h-3 bg-gray-300 rounded w-20"></div>
        <div className="w-4 h-4 bg-gray-300 rounded"></div>
      </div>
    </div>
  </div>
)

const CommissionCardSkeleton = () => (
  <div className="bg-white rounded-xl p-4 shadow border space-y-4 animate-pulse">
    {/* Header with icon and title */}
    <div className="flex items-center gap-2">
      <div className="w-5 h-5 bg-gray-300 rounded"></div>
      <div className="h-4 bg-gray-300 rounded w-36"></div>
    </div>

    {/* Fee items */}
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="h-3 bg-gray-300 rounded w-24"></div>
        <div className="h-8 bg-gray-200 rounded w-full"></div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="h-3 bg-gray-300 rounded w-28"></div>
        <div className="h-8 bg-gray-200 rounded w-full"></div>
      </div>
    </div>

    {/* Dropdown */}
    <div className="flex flex-col gap-1">
      <div className="h-3 bg-gray-300 rounded w-32"></div>
      <div className="h-10 bg-gray-200 rounded w-full"></div>
    </div>
  </div>
)

interface PricingSideMenuSkeletonProps {
  showProMode?: boolean
}

export const PricingSideMenuSkeleton: React.FC<PricingSideMenuSkeletonProps> = ({
  showProMode = false
}) => {
  return (
    <div className="w-full xl:w-[250px] 2xl:w-[320px] flex-none flex flex-col gap-6">
      {/* Mode professionnel section */}
      <div className="bg-white rounded-xl p-4 shadow border animate-pulse">
        <div className="flex items-center justify-between">
          <div className="h-4 bg-gray-300 rounded w-32"></div>
          <div className="w-10 h-5 bg-gray-300 rounded-full"></div>
        </div>
      </div>

      {/* Frais et commissions section (mode pro) */}
      {showProMode && <CommissionCardSkeleton />}

      {/* Filtres section */}
      <div className="bg-white rounded-xl p-4 shadow border space-y-4">
        {/* Filter header */}
        <div className="flex items-center gap-2 animate-pulse">
          <div className="w-5 h-5 bg-gray-300 rounded"></div>
          <div className="h-4 bg-gray-300 rounded w-14"></div>
        </div>

        {/* Filter groups */}
        <div className="flex flex-col gap-4">
          <FilterGroupSkeleton />
          <FilterGroupSkeleton />
        </div>
      </div>
    </div>
  );
};
